import React from "react";
import { motion } from "framer-motion";
import clsx from "clsx";

interface ProgressBarProps {
  totalFiles: number;
  progressFiles: number;
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  totalFiles,
  progressFiles,
  className,
}) => {
  const progress = totalFiles > 0 ? (progressFiles / totalFiles) * 100 : 0;

  return (
    <div className={clsx(["flex", "flex-col", "gap-2", "w-full"])}>
      <div
        className={clsx([
          "flex",
          "w-full",
          "gap-2",
          "justify-between",
          "items-center",
        ])}
      >
        <div className={clsx(["text-base"])}>Espera un momento...</div>
        <div className={clsx(["text-2xl", "font-semibold", "text-white"])}>
          {Math.round(progress)}%
        </div>
      </div>
      <div
        className={clsx(
          ["w-full", "bg-black", "rounded-full", "h-3", "overflow-hidden"],
          className
        )}
      >
        <motion.div
          className={clsx([
            "h-full",
            "bg-lime-500",
            "rounded-sm",
            "flex",
            "items-center",
            "justify-center",
          ])}
          initial={{ width: "0%" }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        ></motion.div>
      </div>
    </div>
  );
};

export default ProgressBar;
